import { ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const simulationForm: ThemedFunctor = ({ theme }) => css`
  max-width: 22rem;
  margin-top: ${theme.remSize[200]};
`;
